import { render } from "./PartnerFormView.vue?vue&type=template&id=ae9a1072&scoped=true"
import script from "./PartnerFormView.vue?vue&type=script&lang=js"
export * from "./PartnerFormView.vue?vue&type=script&lang=js"

import "./PartnerFormView.vue?vue&type=style&index=0&id=ae9a1072&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae9a1072"]])

export default __exports__